const CLIENT_LINK_STATUS_LABELS = {
    INTAKE_OPEN: "Intake in progress",
    INTAKE_IN_PROGRESS: "Intake in progress",
    INTAKE_SUBMITTED: "Intake submitted",
    PREVIEW_READY: "Ready for review",
    CHANGE_REQUESTED: "Changes requested",
    APPROVAL_PENDING: "Waiting for your approval",
    APPROVED: "Approved",
    PORTAL_ACTIVE: "Portal active",
    SAFE_EDIT_ACTIVE: "Safe edit available",
    HANDOFF_READY: "Ready for handoff",
    EXPIRED: "Link expired",
    REVOKED: "Link no longer available",
};
const SECTION_STATE_LABELS = {
    AVAILABLE: "Available now",
    COMING_SOON: "Coming soon",
    LOCKED: "Not available yet",
};
const HANDOFF_ISSUANCE_LABELS = {
    READY: "Ready to download",
    ELIGIBLE: "Ready to package when your agency confirms",
    REQUESTED: "Ready to package when your agency confirms",
    EXPORT_QUEUED: "Preparing your handoff package",
    EXPORTING: "Preparing your handoff package",
    COMPOSING: "Preparing your handoff package",
    BLOCKED: "Handoff package not available yet",
    FAILED: "Handoff package not available yet",
};
const API_ERROR_LABELS = {
    invalid_client_link_url: "This client link is invalid or incomplete. Ask your agency for a new link.",
    client_link_missing_token: "This link is missing its secure access token. Open the full link your agency sent you, including the part after #, or ask them to resend the link.",
    client_link_not_found: "This client link could not be found. Ask your agency for a new link.",
    client_link_revoked: "This client link is no longer available. Contact your agency.",
    client_link_expired: "This client link has expired. Contact your agency for a new link.",
    client_link_domain_not_allowed: "This client link cannot be opened from this address.",
    client_portal_api_error_404: "We could not load your client hub. Please try again or contact your agency.",
    client_report_not_found: "Your search readiness report is not available yet. Your agency can publish one when checks are complete.",
    report_not_ready: "Your search readiness report is still being prepared. Check back soon or contact your agency.",
    report_not_client_safe_ready: "Your search readiness summary is not ready for the client portal yet. Your agency will notify you when it is available.",
    current_client_report_not_found: "No search readiness report is available for this project yet. Your agency can generate one from Studio.",
    client_intake_not_available: "Business intake is not available for this client link right now.",
    client_intake_submit_not_allowed: "Your intake has already been submitted or this link is not open for intake.",
    invalid_client_intake_request: "We could not process your intake form. Please check your entries and try again.",
    approval_requires_shippable_qa: "This preview cannot be approved until its quality check has passed. Contact your agency if the preview was just rebuilt.",
    handoff_requires_client_approval: "Your handoff download is not available until you approve the preview. Open the preview tab to approve, or contact your agency.",
    handoff_approval_stale: "Your approval is out of date because the preview has changed. Please review and approve again before downloading handoff.",
};
const PRIMARY_EVIDENCE_TYPE_LABELS = {
    license_or_certification: "License or certification",
    before_after_photos: "Before and after photos",
    project_portfolio: "Project portfolio",
    emergency_availability: "Emergency availability",
    service_area_coverage: "Service area coverage",
    reviews_or_testimonials: "Reviews or testimonials",
    product_catalog: "Product catalog",
    menu_or_offers: "Menu or offers",
    professional_credentials: "Professional credentials",
    none_yet: "None yet — I will add evidence later",
};
export function toClientLinkStatusLabel(status) {
    return CLIENT_LINK_STATUS_LABELS[status] ?? "Status update";
}
export function toSectionStateLabel(state) {
    return SECTION_STATE_LABELS[state] ?? "Not available yet";
}
export function toHandoffIssuanceLabel(status) {
    return HANDOFF_ISSUANCE_LABELS[status] ?? "Not available yet";
}
export function toClientApiErrorMessage(codeOrMessage) {
    const trimmed = codeOrMessage.trim();
    if (API_ERROR_LABELS[trimmed]) {
        return API_ERROR_LABELS[trimmed];
    }
    const lower = trimmed.toLowerCase();
    for (const [key, label] of Object.entries(API_ERROR_LABELS)) {
        if (lower.includes(key)) {
            return label;
        }
    }
    if (/report/i.test(trimmed) || /readiness/i.test(trimmed)) {
        return "We could not load your search readiness report. Please try again or contact your agency.";
    }
    return "Something went wrong. Please try again or contact your agency.";
}
export const CLIENT_SAFE_EDIT_ACCEPTED_MESSAGE = "Your update was submitted and is processing. It is not live yet.";
export const CLIENT_SAFE_EDIT_REJECTED_MESSAGE = "We could not apply this update. Please check your entry or contact your agency.";
export const CLIENT_SAFE_EDIT_ACTIVE_MESSAGE = "Your update is now active on your preview site.";
export const CLIENT_SAFE_EDIT_QA_BLOCKED_MESSAGE = "Quality checks blocked this update. Contact your agency.";
export const CLIENT_SAFE_EDIT_CONTRADICTION_BLOCKED_MESSAGE = "Conflicting business details blocked this update. Contact your agency to resolve.";
export const CLIENT_SAFE_EDIT_FAILED_MESSAGE = "Processing failed. Contact your agency for help.";
export const CLIENT_CHANGE_REQUEST_SUBMITTED_MESSAGE = "Your change request was sent to your agency.";
export const CLIENT_PREVIEW_APPROVED_MESSAGE = "Thank you — your preview was approved.";
export const CLIENT_PREVIEW_DISCLAIMER = "This is a preview of your website, not your live domain. Your agency will publish changes after approval.";
export const CLIENT_INTAKE_SUBMITTED_MESSAGE = "Thank you — your business details were submitted to your agency.";
export const CLIENT_INTAKE_SUBMITTED_HEADLINE = "Intake submitted";
export const CLIENT_INTAKE_SUBMITTED_BODY = "Your agency will review these details and follow up if anything else is needed before your website draft begins.";
export function toPrimaryEvidenceTypeLabel(type) {
    return PRIMARY_EVIDENCE_TYPE_LABELS[type] ?? "Evidence type";
}
export const PRIMARY_EVIDENCE_TYPE_OPTIONS = Object.entries(PRIMARY_EVIDENCE_TYPE_LABELS).map(([value, label]) => ({ value, label }));
//# sourceMappingURL=tier1-client-display.js.map